import { createBrowserRouter, type RouteObject } from "react-router";
import { page, type FeatureRoutes } from "./feature";
import { Pending } from "./Pending";
import { redirects } from "./redirects";
import { RequireAuth } from "./RequireAuth";
import { RouteError } from "./RouteError";

// Routes come from the features: every src/features/<area>/routes.tsx is picked up here (see feature.ts).
// Those files are tiny and loaded eagerly; the screens they point to are lazy chunks.
const features = import.meta.glob<{ routes: FeatureRoutes }>("../features/*/routes.tsx", { eager: true });
const all = Object.values(features).map((module) => module.routes);
const collect = (part: keyof FeatureRoutes) => all.flatMap((routes) => routes[part] ?? []);

export const routes: RouteObject[] = [
  {
    path: "/",
    errorElement: <RouteError />,
    HydrateFallback: Pending,
    children: [
      ...collect("public"),
      {
        element: <RequireAuth />,
        // The shell (tab bar, side rail, top bar) is its own chunk too: sign-in and full-screen routes skip it.
        children: [
          { lazy: page(() => import("./AppShell")), children: [...collect("shell"), ...redirects] },
          ...collect("fullscreen"),
        ],
      },
      { path: "*", lazy: page(() => import("./NotFound")) },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}
